



















































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DeleteCompanyConfirmModal from './DeleteCompanyConfirmModal.vue';
import type { Company } from '@/models/company';
import { companyWebservice } from '@/webservices/company';
import type { User } from '@/models/user';
import { isSuperAdmin, isSuperAdminNavigationGuard } from '@/helpers/auth/permissionHelpers';

@Component({
    name: 'StoreUpdateCompany',
    methods: { isSuperAdmin },
    components: {
        DeleteCompanyConfirmModal,
    },
})
export default class StoreUpdateCompany extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected removeCompanyErrorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected isRemoving: boolean = false;
    protected state: FormState = FormState.New;

    protected company: Company = {
        setting: {
            feature_tags: false,
            feature_dynamic_worksheet_field: false,
            feature_integrations: false,
            feature_tab_x: false,
        },
    } as Company;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    @Getter('account/userInfo') private userInfo: User;

    // Mounted is called initially
    private mounted() {
        isSuperAdminNavigationGuard(this.userInfo);
        if (this.$route.query.hasOwnProperty('companyId')) {
            this.load(this.$route.query.companyId.toString());
            this.state = FormState.Update;
        }
    }

    private load(companyId: string) {
        this.loading.data = true;
        companyWebservice.getCompanyById(companyId).then((response) => {
            this.company = response.data;
            this.loading.data = false;
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            companyWebservice
                .store(this.company)
                .then(function (response) {
                    self.$router.push({ path: '/system/companies' });
                })
                .catch(function (error) {
                    self.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            companyWebservice
                .updateByMaster(this.company)
                .then(function (response) {
                    self.$buefy.toast.open({
                        duration: 3000,
                        message: 'Successfully Updated',
                        type: 'is-success',
                    });
                    self.disabled = false;
                })
                .catch(function (error) {
                    self.disabled = false;
                    console.log(error);
                });
        }
    }

    private removeCompany(confirmedCompanyName: string, password: string) {
        this.isRemoving = true;
        companyWebservice
            .remove(this.company, confirmedCompanyName, password)
            .then((response) => {
                this.isConfirmModalActive = false;
                this.$router.push({ path: '/system/companies' });
            })
            .catch((error) => {
                console.log(error);
                this.removeCompanyErrorMsg = error.response.data.message;
                this.isRemoving = false;
            });
    }

    private toggleConfirmModal(confirmed: boolean = false, confirmedCompanyName: string, password: string) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
    }

    private validate() {
        // FIXME: Do the validation in parallel, not one after the other
        if (!this.company.name || this.company.name === '') {
            this.errorMsg = 'name';
            return 0;
        } else if (!this.company.email || this.company.email === '' || !this.validateEmail(this.company.email)) {
            this.errorMsg = 'email';
            return 0;
        } else if (!this.company.address || this.company.address === '') {
            this.errorMsg = 'address';
            return 0;
        } else if (!this.company.postcode || this.company.postcode === '') {
            this.errorMsg = 'postcode';
            return 0;
        } else if (!this.company.city || this.company.city === '') {
            this.errorMsg = 'city';
            return 0;
        } else if (!this.company.country || this.company.country === '') {
            this.errorMsg = 'country';
            return 0;
        } else if (
            this.company.setting.feature_dynamic_worksheet_field &&
            !this.company.setting.dynamic_worksheet_field_name
        ) {
            this.errorMsg = 'dynamic_field';
            return 0;
        } else {
            return true;
        }
    }
    private validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
